
import React from "react";
import "./App.css";
import Chat from "./component/Chat";

function App() {
  return (
    <div className="App">
      <Chat />
    </div>
  );
}

export default App;